import getPlatformFromId from "@utils/priceAndCurrencyMethods/getPlatformFromId";

function createSelectList(options, id) {
    const platform = getPlatformFromId(id);
    const arr = options?.map(item => {
        const price = item[platform]?.USD || item.ios.USD;
        return {
            id: item.tier,
            value: price,
            label: `${item.tier} - ${price}`
        };
    });
    return arr.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
}

export default createSelectList;